var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container clearfix"},[_c('div',{staticClass:"footer-content"},_vm._l((_vm.infoList),function(item){return _c('InfoItemI18n',{key:item.left,attrs:{"info":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }